import React from 'react'
import { Slot } from '@radix-ui/react-slot'

export interface ConditionalRenderProps {
  condition: boolean
  children: any
}

export default function ConditionalRender({
  condition,
  children,
}: ConditionalRenderProps) {
  if (!condition) return null
  return (
    <Slot>
      <>{children}</>
    </Slot>
  )
}
